import React, { useContext } from 'react';
import { RowDataItem } from '../grid/OpenSubmissionsGrid';
import { getVenueTypeText, VenueType } from '../../../utils/venueTypeUtils';
import orderBy from 'lodash/orderBy';
import './OpenSubmissionsCapsuleBack.scss';
import AppContext from '../../../app/AppContext';
import Tooltip from '../../../utils/components/Tooltip/Tooltip';

export function OpenSubmissionsCapsuleBack(props: {
    data: RowDataItem[];
    vt: VenueType;
    onClick: () => void;
}) {
    const { data, onClick, vt } = props;

    const rows = orderBy(
        data.filter((r) => r.executionVenueType === vt),
        ['filled', 'orderQty'],
        ['desc', 'desc']
    );

    return (
        <div className="OpenSubmissionsCapsuleBack" onClick={onClick}>
            <div className="venue-type">{getVenueTypeText(vt)}</div>
            <div className="venues">
                <div className="venue-row header">
                    <div className="venue-name">Venue</div>
                    <div className="qty">Amount</div>
                    <div className="filled">Filled</div>
                </div>
                {rows.map((r, i) => (
                    <Row key={i.toString()} row={r} />
                ))}
            </div>
        </div>
    );
}

function Row(props: { row: RowDataItem }) {
    const {
        row: { executionVenueName, orderQty, filled },
    } = props;
    const { numberFormat } = useContext(AppContext);

    return (
        <div className="venue-row">
            <div className="venue-name">
                <Tooltip neverHide={true} text={executionVenueName}>
                    {executionVenueName}
                </Tooltip>
            </div>
            <div className="qty">
                <Tooltip neverHide={true} text={`${numberFormat.n0(orderQty)}`}>
                    {numberFormat.n0(orderQty)}
                </Tooltip>
            </div>
            <div className="filled">
                <Tooltip
                    neverHide={true}
                    text={`${numberFormat.n0(filled)}% filled`}
                >
                    {numberFormat.n0(filled)}%
                </Tooltip>
            </div>
        </div>
    );
}
